'use client';

import Link from 'next/link';
import { MouseEvent } from 'react';
import { Box, Divider, SystemIcon, Typography } from '@wishket/design-system';

import { twMerge } from 'tailwind-merge';

import CollectionThumbnail from './CollectionThumbnail';

interface CollectionMyItemProps {
  id: number | string;
  href: string;
  title: string;
  count?: number;
  isPublic: boolean;
  viewCount?: number;
  imgSrc?: string | null;
  thumbnailMainColor?: string;
  isStatusMenuOpen?: boolean;
  onStatusChangeClick: () => void;
}

const CollectionMyItem = ({
  id,
  href,
  count,
  imgSrc,
  title,
  isPublic,
  viewCount = 0,
  isStatusMenuOpen,
  thumbnailMainColor,
  onStatusChangeClick,
}: CollectionMyItemProps) => {
  const handleStatusChange = (e: MouseEvent) => {
    e.preventDefault();

    onStatusChangeClick();
  };

  return (
    <Link href={href} passHref>
      <Box
        id={`collection-item-${id}`}
        className="flex w-[184px] flex-col gap-4 tablet:w-[232px]"
      >
        <CollectionThumbnail
          size={{
            mobile: 'sm',
            tablet: 'md',
            desktop: 'lg',
          }}
          count={count}
          imgSrc={imgSrc}
          layerColor={thumbnailMainColor}
        />
        <Box className="flex flex-col gap-1.5">
          <Typography
            variant="body1"
            className="line-clamp-1 break-words font-medium text-w-gray-900 tablet:typo-subTitle1"
          >
            {title}
          </Typography>
          <Box className="flex items-center gap-2">
            <Box
              className="flex items-center gap-1.5"
              onClick={(e) => handleStatusChange(e)}
            >
              <SystemIcon
                className="text-w-gray-600"
                name={isPublic ? 'small_public' : 'small_private'}
              />
              <Typography variant="body2" className="text-w-gray-600">
                {isPublic ? '공개' : '비공개'}
              </Typography>
              <Box
                className={twMerge(
                  'transition-transform duration-300',
                  isStatusMenuOpen && 'rotate-180'
                )}
              >
                <SystemIcon
                  name="small_arrow_down"
                  className="text-w-gray-600"
                />
              </Box>
            </Box>
            <Divider isVertical className="h-3.5" />
            <Box className="flex items-center gap-1.5">
              <SystemIcon solid name="small_eye" className="text-w-gray-600" />
              <Typography variant="body2" className="text-w-gray-600">
                {viewCount}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Link>
  );
};

export default CollectionMyItem;
